import { memo } from "react";
import { useDroppable } from "@dnd-kit/core";
import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { useBuilderStore } from "@circle-react-shared/BuilderUI";
import type { DroppableData } from "@circle-react-shared/BuilderUI/BuilderUI.types";
import type { BlockCategoryName } from "@circle-react-shared/BuilderUI/constants/BlockCategories";
import { DropArea } from "./DropArea";

export interface DroppableProps {
  accepts: BlockCategoryName[];
  index?: number;
  path: string;
  rejects: BlockCategoryName[];
}

export const DroppableArea = memo(
  ({ path, accepts, rejects, index }: DroppableProps) => {
    const data: DroppableData = { accepts, rejects, index, path };
    const isDragging = useBuilderStore(state => state.isDragging);
    const id = `${path}:${index ?? 0}`;
    const { isOver, setNodeRef } = useDroppable({ id, data });

    return (
      <div
        data-droppable-area
        className={classNames("wb-h-[1rem] wb-z-10 wb-mb-[-1rem] wb-w-full", {
          "wb-hidden": !isDragging,
        })}
        ref={setNodeRef}
        data-testid="canvas-droppable-area"
      >
        <DropArea isOver={isOver} accepts={accepts} rejects={rejects} />
      </div>
    );
  },
);

DroppableArea.displayName = "DroppableArea";
